import React from "react";
import { host, host_v2 } from "../../utilities/requests";
import PropTypes from 'prop-types';
import { decrementPending, incrementPending } from "../../containers/actions";
import _ from "lodash";
export default class ConsolidatedReports extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    constructor(props) {
        super(props);
        this.fetch = this.fetch.bind(this);
    }
    componentWillMount() {
        this.fetch();
    }

    state = {
        bakhe: {
            data: [],
            openMenu: false,
            selectedIds: [],
        },
        helli: {
            data: [],
            openMenu: false,
            selectedIds: [],
        },
        AnalyzeType:0
    }

    async fetch() {
        try {
            const now = new window.MomentJalali();
            if (now.jMonth() < 5){ now.add(-1, 'jYear') }
            now.jMonth(5);
            now.startOf('jMonth');
            let currentYear = (now.toDate().getTime() / 1000 + 12600 );
            now.add(1, 'jYear');
            currentYear += ',' + (now.toDate().getTime() / 1000 + 12600) ;
            var token = this.context.store.getState().get('application').get('token');
            await Promise.all(_.map(["bakhe" , "helli"] , async(exam)=>{
                let examType = exam === "bakhe" ? 1 : 2;
                this.context.store.dispatch(incrementPending())
                const path = `${host}/api/examination/?examination_type=${examType}&limit=10000&date__range=${currentYear}&react__route=${window.location.pathname}`
                const res = await fetch(path, {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                    }
                })
                const data = await res.json();
                if (examType === 1) {
                    this.setState({ ...this.state, bakhe: { ...this.state.bakhe, data: data.results } })
                }
                else if (examType === 2) {
                    this.setState({ ...this.state, helli: { ...this.state.helli, data: data.results } })
                }
                this.context.store.dispatch(decrementPending())
            }))

        }
        catch (err) {
            console.log(err)
            alert("مشکلی پیش آمده است")
        }
    }

    handleClickBakhe(event, title) {
        let arr = [...this.state.bakhe.selectedIds , {id:Number(event.target.attributes["value"].value) , title:title}];
        this.setState({ ...this.state, bakhe: { ...this.state.bakhe, selectedIds:_.uniqBy(arr , "id"), openMenu: false } })
    }

    handleClickHelli(event, title) {
        let arr = [...this.state.helli.selectedIds , {id:Number(event.target.attributes["value"].value) , title}]
        this.setState({ ...this.state, helli: { ...this.state.helli, selectedIds:_.uniqBy(arr , "id"), openMenu: false } })
    }

    handleRemoveItem(examType , id){
        if(examType === "bakhe"){
            let arr = this.state.bakhe.selectedIds.filter((item)=>item.id != id);
            this.setState({...this.state , bakhe:{...this.state.bakhe , selectedIds:arr}});
        }
        else if(examType ==="helli"){
            let arr = this.state.helli.selectedIds.filter((item)=>item.id != id);
            this.setState({...this.state , helli:{...this.state.helli , selectedIds:arr}});
        }
    }
    btnstyle = {
        padding: "0.5em",
        fontFamily: "IRANSans, Arial, sans-serif",
        fontSize: "0.9em",
        borderWidth: "medium",
        borderStyle: "none",
        borderColor: "currentcolor",
        cursor: " pointer",
        outline: "none",
        minWidth: "6em",
        margin: "0px 0.5em 0px 0px",
        backgroundColor: "white",
        color: "black",
        borderRadius: "0.15em",
        boxShadow: "rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px",
    }

    async analysisReport(analyzeType = 0) {
        try {
            this.context.store.dispatch(incrementPending())
            var token = this.context.store.getState().get('application').get('token');
            const payload = { BakheExamId: _.map(this.state.bakhe.selectedIds , "id"),
                              AllameExamId: _.map(this.state.helli.selectedIds , "id"),
                              ExamAnalyzeType: analyzeType }
            const res = await fetch(`${host_v2}/api/ConsolidateReportApi/StartAnalyze/`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                },
                body: JSON.stringify(payload)
            });
            var result = await res.json();
            this.context.store.dispatch(decrementPending())
            if(result.errorTitle){
                alert(result.errorTitle)
            }
            else return
        }
        catch (err) {
            console.log(err)
            alert("مشکلی پیش آمده است")
        }
    }

    async checkAnalysisReport(){
        try{
            this.context.store.dispatch(incrementPending())
            var token = this.context.store.getState().get('application').get('token');
            const payload = { BakheExamId: _.map(this.state.bakhe.selectedIds , "id"), AllameExamId: _.map(this.state.helli.selectedIds , "id") }
            const res = await fetch(`${host_v2}/api/ConsolidateReportApi/CheckExamsCanAnalyze`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": `${token.get('tokenType')} ${token.get('accessToken')}`
                },
                body: JSON.stringify(payload)
            });
            var response = await res.json();
            if(response.errorId === 0){
                alert(response.result)
            }
            else {
                alert(response.errorTitle)
            }
            this.context.store.dispatch(decrementPending())

        }
        catch(err){
            console.log(err)
        }
    }

    render() {
        return <div>
            <div className="consolidated-box-container">
                <div style={{ width: "100%", display: "flex", justifyContent: "center"  }}>
                    <div style={{ width: "100%", margin: "0px 0.5em 0px 0px",  }}>
                        <p style={{ marginBottom: "6px" }}>{window.gettext("انتخاب آزمون باخه")}</p>
                        <div className="consolidated-box-selectbtnbox">
                            <div className="consolidated-box-selectbtn" 
                                onClick={() => {
                                     this.setState({ ...this.state, bakhe: { ...this.state.bakhe, openMenu: !this.state.bakhe.openMenu } }) }}>
                                <p className="consolidated-box-selectText">انتخاب آزمون</p>
                                <i className="fa-chevron-down fa-chevron-down-icon"></i>
                            </div>
                            <div className="consolidated-box-selectbtn">
                                <div>
                                    {this.state.bakhe.selectedIds.map((item)=>
                                        <div style={{display:"flex" , alignItems:"center"}}>
                                            <i 
                                                value={item.id}
                                                onClick={()=>{this.handleRemoveItem("bakhe" , item.id)}}
                                                className="fa fa-times" style={{marginLeft:".5rem" , color:"#333"}}></i>
                                            <p className="consolidated-box-selectText">{item.title}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="consolidated-selectBox" style={{ display: this.state.bakhe.openMenu ? "block" : "none" }} >
                                {this.state?.bakhe.data ?
                                    this.state?.bakhe.data.map((item) => (<div className="consolidated-selectBox-item" value={item.id} 
                                    onClick={(e) => { this.handleClickBakhe(e, `${item.id.persian()} - ${item.title} -  ${item.grades[0].title}`) }}>
                                        <p className="consolidated-selectBox-item-text">{item.id.persian()} - {item.title} -  {item.grades[0].title}</p>
                                    </div>))
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                    <div style={{ width: "100%", margin: "0px 0.5em 0px 0px", }}>
                        <p style={{ marginBottom: "6px" }}>{window.gettext("انتخاب آزمون حلی")}</p>
                        <div className="consolidated-box-selectbtnbox">
                            <div className="consolidated-box-selectbtn" onClick={() => { this.setState({ ...this.state, helli: { ...this.state.helli, openMenu: !this.state.helli.openMenu } }) }}>
                                <p className="consolidated-box-selectText">انتخاب آزمون</p>
                                <i className="fa-chevron-down fa-chevron-down-icon"></i>
                            </div>
                            <div className="consolidated-box-selectbtn">
                                <div>
                                    {this.state.helli.selectedIds.map((item)=>
                                        <div style={{display:"flex" , alignItems:"center"}}>
                                            <i 
                                                value={item.id}
                                                onClick={()=>{this.handleRemoveItem("helli" , item.id)}}
                                                className="fa fa-times" style={{marginLeft:".5rem" , color:"#333"}}></i>
                                            <p className="consolidated-box-selectText">{item.title}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="consolidated-selectBox" style={{ display: this.state.helli.openMenu ? "block" : "none" }} >
                                {this.state?.helli?.data ?
                                    this.state?.helli?.data.map((item) => (<div className="consolidated-selectBox-item" value={item.id}
                                        onClick={(e) => { this.handleClickHelli(e, `${item.id.persian()} - ${item.title} -  ${item.grades[0].title}`) }}>
                                        <p className="consolidated-selectBox-item-text">{item.id.persian()} - {item.title} -  {item.grades[0].title}</p>
                                    </div>))
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                    <button style={{ ...this.btnstyle, color: "#fff", backgroundColor: "#dc3545", width: "250px" }} onClick={()=>{this.state.bakhe.selectedIds && this.state.helli.selectedIds && this.checkAnalysisReport()}}>
                        {window.gettext("بررسی امکان تحلیل")}
                    </button>
                    <button style={{ ...this.btnstyle, color: "#fff", backgroundColor: "rgb(50,50,255)", width: "250px" }} onClick={()=>{this.state.bakhe.selectedIds && this.state.helli.selectedIds && this.analysisReport(0)}}>
                        {window.gettext("تحلیل کل جامعه")}
                    </button>
                    <button style={{ ...this.btnstyle, color: "#fff", backgroundColor: "rgb(142, 68, 173)", width: "250px" }} onClick={()=>{this.state.bakhe.selectedIds && this.state.helli.selectedIds && this.analysisReport(1)}}>
                        {window.gettext("تحلیل به تفکیک")}
                    </button>
                </div>
            </div>
        </div>
    }
}
